//! Accesso ai dati aggregati di un market (volume, liquidità, numero di trade).
//!
//! I tre campi sono serializzati dal backend come Decimal-stringa (`"1250.00"`),
//! tranne `trade_count` che è un intero. Questo modulo è l'unico punto che li
//! legge: card, tabella, hero e dettaglio passano da `marketMetrics()`.

import { parseDecimal } from "@/components/atoms/format";
import type { components } from "./schema.gen";

type MarketView = components["schemas"]["MarketView"];

/** TEMPORANEO — rimuovere quando `npm run typegen` rigenererà `schema.gen.ts`
 *  con `liquidity`, `volume` e `trade_count` dentro `MarketView`.
 *  A quel punto questo alias può diventare semplicemente `MarketView`.
 *
 *  I campi restano opzionali qui così il codice compila e gira sia prima
 *  (API/typegen non ancora aggiornati → fallback a 0) sia dopo. */
export type MarketWithMetrics = MarketView & {
  liquidity?: string | null;
  volume?: string | null;
  trade_count?: number | null;
};

export interface MarketMetrics {
  /** Volume scambiato, in USD. */
  volume: number;
  /** Liquidità disponibile a book, in USD. */
  liquidity: number;
  /** Numero di trade eseguiti. */
  tradeCount: number;
}

/** Estrae le metriche da un market, con fallback a 0 su campi assenti.
 *  Difensivo di proposito: i market appena creati non hanno ancora attività
 *  e l'API potrebbe non esporre ancora i campi. */
export function marketMetrics(market: MarketWithMetrics): MarketMetrics {
  const tradeCount = Number(market.trade_count ?? 0);
  return {
    volume: parseDecimal(market.volume),
    liquidity: parseDecimal(market.liquidity),
    tradeCount: Number.isFinite(tradeCount) ? tradeCount : 0,
  };
}
